export default "__VITE_ASSET__TJMmMKWn__"